// extracted by mini-css-extract-plugin
export var root = "styles-module--root--1HZIw";
export var shadow = "styles-module--shadow--2mfgE";
export var close = "styles-module--close--Kaz-_";
export var content = "styles-module--content--3jyrz";
export var form = "styles-module--form--2SRQ5";
export var header = "styles-module--header--24ORd";
export var warning = "styles-module--warning--2ttFw";
export var bold = "styles-module--bold--11ZnR";
export var emailLink = "styles-module--emailLink--FRXLJ";